module.exports = __webpack_public_path__ + "img/W7042-trad.71e571dc.jpg";